import { authHeader, fetch_request } from '../../../service/request';
import { getMessengerV2PresenceSessionId } from './presenceSession.js';

const sendPresenceRequest = async (path, { keepalive = false } = {}) => {
  const sessionId = getMessengerV2PresenceSessionId();
  const response = await fetch_request(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({
      session_id: sessionId,
    }),
    keepalive,
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};

export const pingMessengerV2Presence = async () =>
  sendPresenceRequest('/api/presence/ping');

export const leaveMessengerV2Presence = async ({ keepalive = false } = {}) =>
  sendPresenceRequest('/api/presence/leave', { keepalive });

const presenceService = {
  pingMessengerV2Presence,
  leaveMessengerV2Presence,
};

export default presenceService;
